import type { IPickerOption } from './IPickerOption';

/** Пошук у пікері з першого символу: без урахування регістру за підписом і уточненням (прототип pickerVM). */
export function filterOptions(options: IPickerOption[], query: string): IPickerOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return options;
  return options.filter((o) => `${o.label} ${o.sub ?? ''}`.toLowerCase().includes(q));
}
